import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Typography, Box, FormControl, InputLabel, Select, MenuItem, Button, DialogContent, TextField, Grid, FormControlLabel, Divider, Chip } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Dialog } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { Add, AddBox, CheckBox, CheckBoxTwoTone, Delete, Edit, Square } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

function AddEditForm({ open, handleClose, item, fetchParamsData, data, selectedParamType, inventoryData = [], stdValue = [] }) {
  const swal = useSwalWrapper();
  const [isLoading, setIsLoading] = useState(false);
  const validationSchema = Yup.object({
    FL_PARA_NAME: Yup.string().required('Parameter Name is required'),
    FL_PARA_VALUE: Yup.string().required('Parameter Value is required'),
    FL_NARRATION: Yup.string().required('Narration is required'),
    // FL_COMP_SEQ: Yup.number().required('Company Sequence is required'),
    FL_PARENT_SEQ: Yup.number().required('Parent Sequence is required'),
  });

  const formik = useFormik({
    initialValues: {
      FL_GPID: item?.FL_GPID || null,
      FL_NATURE_LIST: item?.FL_NATURE_LIST || null,
      FL_INV_TYPE_LIST: item?.FL_INV_TYPE_LIST || null,
      FL_PARA_NAME: item?.FL_PARA_NAME || '',
      FL_PARA_VALUE: item?.FL_PARA_VALUE || '',
      FL_NARRATION: item?.FL_NARRATION || '',
      // FL_COMP_SEQ: item?.FL_COMP_SEQ || 1,
      FL_PARENT_SEQ: item?.FL_PARENT_SEQ || 0,
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true)
      // Convert boolean values back to 1 or 0
      const submittedData = await {
        ...values
      };
      await jwtAuthAxios.post('master/addEditglobleParams', submittedData).then(async response => {
        if (response.data.status == 'success') {
          swal.fire({
            icon: 'success',
            text: response.data.message || 'Parmas Added',
          });
          await formik.resetForm();
          handleClose();
          fetchParamsData();
        } else {
          swal.fire({
            icon: 'error',
            text: response.data.message || 'Something Went Wrong',
          });
        }
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server error',
        });
        return false
      }).finally(() => {
        setIsLoading(false)
      })
    },
  });
  // const formik = useFormik({
  //   initialValues: {
  //     FL_ID: item?.FL_ID || '',
  //     FL_PARAM_TYPE: item?.FL_PARAM_TYPE || '',
  //     FL_NAME: item?.FL_NAME || '',
  //     FL_SHORT_NAME: item?.FL_SHORT_NAME || '',
  //     FL_GROUP_NAME: item?.FL_GROUP_NAME || '',
  //     FL_PC: item?.FL_PC === 1, // Convert 1 to true and 0 to false
  //     FL_RAP_PRICE: item?.FL_RAP_PRICE || '',
  //     FL_RAP_DISCOUNT_PER: item?.FL_RAP_DISCOUNT_PER || null,
  //     FL_STD_VALUR: item?.FL_STD_VALUR || '',
  //     FL_INVENTORY_TYPE: item?.FL_INVENTORY_TYPE?.split(',') || [],
  //     FL_SHORT_NO: item?.FL_SHORT_NO || 0,
  //     FL_IS_ACTIVE: item?.FL_IS_ACTIVE === 1, // Convert 1 to true and 0 to false
  //   },
  //   validationSchema,
  //   onSubmit: async (values) => {
  //     setIsLoading(true)
  //     // Convert boolean values back to 1 or 0
  //     const submittedData = await {
  //       ...values,
  //       FL_INVENTORY_TYPE: values.FL_INVENTORY_TYPE.join(','),
  //       FL_PC: values.FL_PC ? 1 : 0,
  //       FL_IS_ACTIVE: values.FL_IS_ACTIVE ? 1 : 0,
  //     };
  //     await jwtAuthAxios.post('master/addEdit', submittedData).then(async response => {
  //       if (response.data.status == 'success') {
  //         swal.fire({
  //           icon: 'success',
  //           text: response.data.message || 'Parmas Added',
  //         });
  //         await formik.resetForm();
  //         handleClose();
  //         fetchParamsData();
  //       } else {
  //         swal.fire({
  //           icon: 'error',
  //           text: response.data.message || 'Something Went Wrong',
  //         });
  //       }
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server error',
  //       });
  //       return false
  //     }).finally(() => {
  //       setIsLoading(false)
  //     })
  //     // Close the form after submission


  //   },
  // });
  useEffect(() => {
    formik.setValues({
      FL_GPID: item?.FL_GPID || null,
      FL_NATURE_LIST: item?.FL_NATURE_LIST || null,
      FL_INV_TYPE_LIST: item?.FL_INV_TYPE_LIST || null,
      FL_PARA_NAME: item?.FL_PARA_NAME || '',
      FL_PARA_VALUE: item?.FL_PARA_VALUE || '',
      FL_NARRATION: item?.FL_NARRATION || '',
      FL_PARENT_SEQ: item?.FL_PARENT_SEQ || 0,
    });
  }, [item]);




  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Typography variant="h3" gutterBottom>
          {item?.FL_ID ? 'Edit Item' : 'Add Item'}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                type="text"
                placeholder='PARA NAME'
                label='PARA NAME'
                name="FL_PARA_NAME"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={selectedParamType == formik.values.FL_PARA_NAME }
                value={formik.values.FL_PARA_NAME}
                error={formik.touched.FL_PARA_VALUE && formik.errors.FL_PARA_VALUE}
                helperText={formik.touched.FL_PARA_VALUE && formik.errors.FL_PARA_VALUE}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                 type="text"
                 placeholder='PARA VALUE'
                 label='PARA VALUE'
                 name="FL_PARA_VALUE"
                 onChange={formik.handleChange}
                 onBlur={formik.handleBlur}
                 value={formik.values.FL_PARA_VALUE}
                 error={formik.touched.FL_PARA_VALUE && formik.errors.FL_PARA_VALUE}
                 helperText={formik.touched.FL_PARA_VALUE && formik.errors.FL_PARA_VALUE}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                type="text"
                placeholder='NARRATION'
                label='NARRATION'
                name="FL_NARRATION"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.FL_NARRATION}
                error={formik.touched.FL_NARRATION && formik.errors.FL_NARRATION}
                helperText={formik.touched.FL_NARRATION && formik.errors.FL_NARRATION}
                fullWidth
              />
            </Grid>
            {/* <Grid item xs={6}>
              <TextField
                type="number"
                placeholder='COMP SEQ'
                label='COMP SEQ'
                name="FL_COMP_SEQ"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.FL_COMP_SEQ}
                error={formik.touched.FL_COMP_SEQ && formik.errors.FL_COMP_SEQ}
                helperText={formik.touched.FL_COMP_SEQ && formik.errors.FL_COMP_SEQ}
                fullWidth
              />
            </Grid> */}
            <Grid item xs={6}>
              <TextField
                type="number"
                placeholder='PARENT SEQ'
                label='PARENT SEQ'
                name="FL_PARENT_SEQ"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.FL_PARENT_SEQ}
                error={formik.touched.FL_PARENT_SEQ && formik.errors.FL_PARENT_SEQ}
                helperText={formik.touched.FL_PARENT_SEQ && formik.errors.FL_PARENT_SEQ}
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider sx={{ mb: 3, mt: 2 }} />
          <LoadingButton loading={isLoading} variant="contained" size='large' sx={{ mr: 3 }} color="primary" type="submit">
            Save
          </LoadingButton>
          <Button variant="outlined" size='large' color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
function AllParametersTab() {
  const [selectedParamType, setSelectedParamType] = useState(null);
  const [data, setData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [paramTypes, setParamTypes] = useState([]);
  const [stdValue, setStdValue] = useState([]);
  const [openAddEditForm, setOpenAddEditForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const swal = useSwalWrapper();
  const fetchParamsData = useCallback(async (value = null) => {
    setData([]);
    value == null && setSelectedParamType(null)
    jwtAuthAxios.get(`master/globleParams${value != null ? '?param=' + value : ''}`).then(data => {
      if (data.data.status === 'success') {
        if (value == null) {
          setParamTypes(data.data.rows);
          data?.data?.inventory && setInventoryData(data.data.inventory);
        } else {
          
          setData(data.data.rows)
          data?.data?.stdValue && setStdValue(data.data.stdValue)
        }
      }
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server error',
      });
    })
  }, []);


  useEffect(() => {
    fetchParamsData();
    
  }, []);

  const handleParamChange = async (event) => {
    setSelectedParamType(event.target.value);
    fetchParamsData(event.target.value)
  };

  // const uniqueParamTypes = [...new Set(data.map((param) => param.FL_PARAM_TYPE))];

  const handleOpenAddEditForm = (item) => {
    setSelectedItem(item);
    setOpenAddEditForm(true);
  };

  const handleAddEditFormClose = () => {
    setSelectedItem(null);
    setOpenAddEditForm(false);
  };


  return (
    <>
      <Paper elevation={3} style={{ padding: '20px' }}>
        <Grid container>
          <Grid item lg={6}>
            <Typography variant="h3" sx={{ mb: 3 }} gutterBottom>
              Globle Parameter Master
            </Typography>
          </Grid>
          <Grid item lg={6}>
            <Div sx={{ display: 'flex', gap: '20px', justifyContent: 'end' }}><FormControl style={{ minWidth: 200, marginBottom: 20 }}>
              {selectedParamType == null && <InputLabel sx={{ mb: 0 }}>{paramTypes.length ==0 ?'Loading Data':'Parameter Type'}</InputLabel>}
              <Select
                value={selectedParamType}
                onChange={handleParamChange}
                sx={{ mb: '-20px' }}
                disabled={paramTypes.length ==0}
              >
                {paramTypes.map(({ PARAMTYPE }) => (
                  <MenuItem key={PARAMTYPE} value={PARAMTYPE}>
                    {PARAMTYPE}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              <LoadingButton
                variant="contained"
                color="primary"
                loading={paramTypes.length ==0 }
                size='large'
                onClick={() => handleOpenAddEditForm({})}
              >
                Add New
              </LoadingButton></Div>
          </Grid>
        </Grid>
      </Paper>
      {selectedParamType != null && <ParameterInfo data={data} isStdVal={stdValue.length > 0} onEdit={handleOpenAddEditForm} />}
      <AddEditForm
        open={openAddEditForm}
        handleClose={handleAddEditFormClose}
        item={selectedItem}
        data={data}
        inventoryData={inventoryData}
        selectedParamType={selectedParamType}
        fetchParamsData={fetchParamsData}
        stdValue={stdValue}
      />
    </>
  );
}

function ParameterInfo({ data, onEdit, isStdVal }) {
  return (
    <TableContainer  sx={{ mt: 3 }} component={Paper}>
    {data.length >0 ? 
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell >ID</TableCell>
            <TableCell >PARA NAME</TableCell>            
            <TableCell >PARA VALUE</TableCell>            
            <TableCell >NARRATION</TableCell>            
            <TableCell >ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index+1}</TableCell>
              <TableCell>{item.FL_PARA_NAME}</TableCell>
              <TableCell>{item.FL_PARA_VALUE}</TableCell>
              <TableCell>{item.FL_NARRATION}</TableCell>
              <TableCell>
                <Div> <Button
                  size="small"
                  color="secondary"
                  sx={{ px: 0, borderRadius: '50%', width: '32px', height: '32px', minWidth: 'auto' }}
                  onClick={() => onEdit(item)}
                >
                  <Edit />
                </Button>
                  <Button color="error" size="small" sx={{ px: 0, borderRadius: '50%', width: '32px', height: '32px', minWidth: 'auto' }}>
                    <Delete />
                  </Button></Div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>: <TableSkeleton cols={10} row={10}/>}
    </TableContainer>
  );
}


AllParametersTab.Modulename = 'globleparams'
export default AllParametersTab;
